// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lp-description[data-v-5eb4209a]{max-width:673px}[data-v-5eb4209a] .lp-description a{font-weight:700}.l-cases[data-v-5eb4209a]{margin-top:12px}.edit[data-v-5eb4209a]{position:relative}.edit-btn[data-v-5eb4209a]{position:absolute;right:-8px;top:-6px;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
